import { createFileRoute } from '@tanstack/react-router'
import { format } from 'date-fns'
import { parse } from 'valibot'

import { getMonthlyCustomerReportQueryOptions } from '@/features/monthly-customer-reports/query-options'

import { monthlyCustomerReportParamsSchema } from '../-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/$monthlyCustomerReportId'
)({
  parseParams: (params) => parse(monthlyCustomerReportParamsSchema, params),
  loader: async ({
    params: { tenantKey, monthlyCustomerReportId },
    context: { queryClient }
  }) => {
    const monthlyCustomerReport = await queryClient.fetchQuery(
      getMonthlyCustomerReportQueryOptions({
        tenantKey,
        monthlyCustomerReportId
      })
    )
    return {
      monthlyCustomerReport
    }
  },
  meta: ({ loaderData }) => [
    {
      title: `${format(loaderData.monthlyCustomerReport.operatingYearMonth, 'yyyy/MM')} - ${loaderData.monthlyCustomerReport.customer.name}`
    }
  ]
})
